import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, GitCompare, ShoppingCart } from 'lucide-react';
import { CatalogAPI } from '../lib/api';

const load = () => { try { return JSON.parse(localStorage.getItem('dz_compare') || '[]'); } catch { return []; } };

const readCartSupplierIds = () => {
  try {
    const cart = JSON.parse(localStorage.getItem('dz_cart') || '[]');
    return new Set(cart.map(it => it?.variant?.supplier_id).filter(Boolean));
  } catch { return new Set(); }
};

const CompareBar = () => {
  const [ids, setIds] = useState(load);
  const [prods, setProds] = useState([]);
  const [cartSupplierIds, setCartSupplierIds] = useState(readCartSupplierIds);

  useEffect(() => {
    const refresh = () => setIds(load());
    window.addEventListener('compare-changed', refresh);
    window.addEventListener('storage', refresh);
    return () => { window.removeEventListener('compare-changed', refresh); window.removeEventListener('storage', refresh); };
  }, []);

  useEffect(() => {
    const refresh = () => setCartSupplierIds(readCartSupplierIds());
    window.addEventListener('cart-changed', refresh);
    window.addEventListener('storage', refresh);
    return () => { window.removeEventListener('cart-changed', refresh); window.removeEventListener('storage', refresh); };
  }, []);

  useEffect(() => {
    if (ids.length === 0) { setProds([]); return; }
    Promise.all(ids.map(id => CatalogAPI.product(id).catch(() => null))).then(res => setProds(res.filter(Boolean)));
  }, [ids]);

  const remove = (id) => { const next = ids.filter(x => x !== id); localStorage.setItem('dz_compare', JSON.stringify(next)); setIds(next); window.dispatchEvent(new Event('compare-changed')); };
  const clear = () => { localStorage.setItem('dz_compare', '[]'); setIds([]); window.dispatchEvent(new Event('compare-changed')); };
  if (ids.length === 0) return null;

  const productHasCartSupplier = (p) => (p?.variants || []).some(v => cartSupplierIds.has(v.supplier_id));

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#E8E0D0] shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-4">
        <div className="flex items-center gap-2 text-sm font-medium text-[#1F4D3F] shrink-0">
          <GitCompare className="w-4 h-4" /><span className="hidden sm:inline">Comparer ({ids.length}/4)</span>
        </div>
        <div className="flex-1 flex items-center gap-2 overflow-x-auto no-scrollbar">
          {prods.map(p => {
            const matchesCart = productHasCartSupplier(p);
            return (
              <div
                key={p.id}
                className={`flex items-center gap-2 border rounded-lg px-2.5 py-1.5 shrink-0 ${matchesCart ? 'bg-[#1F4D3F]/5 border-[#1F4D3F]/40' : 'bg-[#F5F1EA] border-[#E8E0D0]'}`}
                data-testid={`compare-chip-${p.id}`}
              >
                {matchesCart && (
                  <span
                    className="w-5 h-5 rounded-full bg-[#1F4D3F] text-white flex items-center justify-center"
                    title="Disponible chez un fournisseur déjà dans votre panier"
                    data-testid={`compare-chip-match-${p.id}`}
                  >
                    <ShoppingCart className="w-3 h-3" />
                  </span>
                )}
                <img src={p.image} alt="" className="w-7 h-7 rounded object-cover" onError={e => { e.target.style.display='none'; }} />
                <span className="text-xs text-[#2D2A26] max-w-[100px] truncate font-medium">{p.name}</span>
                <button onClick={() => remove(p.id)} className="text-[#7A6F5C] hover:text-[#C75B27] ml-1"><X className="w-3.5 h-3.5" /></button>
              </div>
            );
          })}
          {Array.from({ length: 4 - ids.length }).map((_, i) => (
            <div key={`placeholder-${ids.length}-${i}`} className="w-24 h-9 border-2 border-dashed border-[#E8E0D0] rounded-lg shrink-0 flex items-center justify-center text-[#C9BFAE] text-xs">+</div>
          ))}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button onClick={clear} className="text-xs text-[#7A6F5C] hover:text-[#C75B27] hidden sm:block">Vider</button>
          <Link to="/comparer" className="bg-[#1F4D3F] hover:bg-[#173B30] text-white text-sm font-medium px-4 py-2 rounded-xl transition-colors whitespace-nowrap">Comparer →</Link>
        </div>
      </div>
    </div>
  );
};
export default CompareBar;
